import Link from 'next/link';
import styles from './index.module.scss';

export const Footer = () => {
  return (
    <div className={styles.panel}>
      <div className={styles.content}>
        <div className={styles.brand}>DavidSainez</div>
        <div className={styles.nav}>
          <div className={styles.heading}>Navigation</div>
          <Link href="/">Writing</Link>
          <Link href="/me">Me</Link>
        </div>
        <div id={styles.links}>
          <div className={styles.heading}>Contact</div>
          <a id={styles.linkItem} href="mailto:hello@davidsainez.com">
            Email
          </a>
          <a id={styles.linkItem} href="https://twitter.com/davidsainez">
            Twitter
          </a>
          <a id={styles.linkItem} href="https://github.com/davidsainez">
            GitHub
          </a>
          <a
            id={styles.linkItem}
            href="https://news.ycombinator.com/user?id=sainez"
          >
            HackerNews
          </a>
          <a
            id={styles.linkItem}
            href="https://stackoverflow.com/users/7077117/david-sainez"
          >
            StackOverflow
          </a>
        </div>
        <div className={styles.copyright}>
          Copyright © 2024 David Varela-Sainez. All rights reserved.
        </div>
      </div>
    </div>
  );
};
